module.exports = __webpack_public_path__ + "img/theodore-alexander-mobile.68942ae.jpg";